import React, { ReactNode } from 'react';
import useSubscriptionValidation from './validateBilling';

interface Props {
    children: ReactNode;
}

const ValidateSubscriptionComponent = ({ children }: Props) => {
    // currently disabling in-app purchases feature
    const isValidSubscription = useSubscriptionValidation();
    // console.log(isValidSubscription);
    return isValidSubscription ? <>{children}</> : null;
    // return <>{children}</>
};

export default ValidateSubscriptionComponent;
